'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UITranslatable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _utils = require('./utils');

var _I18nContext = require('../context/I18nContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypesWithoutI18n = function propTypesWithoutI18n(propTypes) {
  var newPropTypes = _extends({}, propTypes);
  delete newPropTypes.I18n;
  return newPropTypes;
};

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {React.Component}
 */
function UITranslatable(InputComponent) {
  var controlledComponent = _react2.default.createClass({
    displayName: 'Translatable(' + (0, _reactUtils.getComponentName)(InputComponent) + ')',

    propTypes: propTypesWithoutI18n(InputComponent.propTypes),

    /**
     * @return {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return _extends({}, InputComponent.defaultProps);
    },


    /**
     * @return {React.Element}
     */
    render: function render() {
      var _this = this;

      this._refCallback = this._refCallback || (0, _utils.makeDecoratorRefCallback)(InputComponent, this);
      return _react2.default.createElement(
        _I18nContext.Consumer,
        null,
        function (i18nContext) {
          return _react2.default.createElement(InputComponent, _extends({}, _this.props, {
            ref: _this._refCallback,
            I18n: i18nContext.I18n
          }));
        }
      );
    }
  });

  (0, _utils.attachWrappedComponent)(controlledComponent, InputComponent);

  return controlledComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/decorators/Translatable.js
// module id = 62
// module chunks = 0